/**
 * Default Selectize config
 */

var VRC = VRC || {};

VRC.Utils = VRC.Utils || {};


VRC.Utils.Selectize = (function(){
  var _config = {
    plugins: [],
    highlight : false,
    sortField: 'text',
    searchField: ['text'],
    lockOptgroupOrder : true
  };

  return {
    getConfig : function(){
      return _config;
    }
  }
})();